import React, { Fragment } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { IntlProvider } from "react-intl";
import { NotificationContainer } from "Components/ReactNotifications";
import { defaultStartPath } from "Constants/defaultValues";
import { useAppSelector } from "Redux/hooks";

import AppLocale from "../lang";
import MainRoute from "Routes";
import ErrorPage from "Routes/error";
import Login from "Routes/extras/login";
import Register from "Routes/extras/register";
import ForgotPassword from "Routes/extras/forgot-password";

import "bootstrap/dist/css/bootstrap.min.css";
import "Assets/fonts/simple-line-icons/css/simple-line-icons.css";
import "Assets/fonts/iconsmind/style.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "Assets/css/sass/themes/reactify.light.purple.scss";

function AppContent() {
  const locale = useAppSelector(s => s.settings.locale);
  const location = useLocation();
  const currentAppLocale = AppLocale[locale];
  const path = location.pathname;

  if (path === "/" || path === "/app" || path === "/app/") {
    return <Navigate to={defaultStartPath} replace />;
  }

  return (
    <Fragment>
      <NotificationContainer />
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <Routes>
          <Route path="/app/*" element={<MainRoute />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="*" element={<Navigate to="/error" replace />} />
        </Routes>
      </IntlProvider>
    </Fragment>
  );
}

export default AppContent;
